import Modal from "../modal/modal.js";

export default class CTAPopup {
	constructor(config) {
		this.el = config.el || document.querySelector(".cta--popup");
		this.main = document.getElementById("main");
		this.modalId = "cta-modal-" + this.el.dataset.title;

		this.modalEl = document.querySelector(
			"[data-id='" + this.modalId + "']"
		);
		this.init();
	}
	init() {
		this.attachEvents();
	}
	attachEvents() {
		const self = this;

		this.el.addEventListener("click", event => {
			self.openModal();
		});
	}

	openModal() {
		new Modal(this.modalEl, this.el).show();
	}

	evaluateUrl() {
		var hashValue = decodeURI(document.location.hash);
		if (hashValue) {
			var modalId = "ctaModal_" + hashValue.replace("#", "");
			const modalElement = document.querySelector(
				"[data-id='" + modalId + "']"
			);
			if (modalElement) {
				new Modal(modalId).show();
			}
		}
	}
}
